module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-8-45ccb0779eb9bebf55728cfad62e38c8.jpg";